import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../globalInspector/axiosInstance";
import { env } from "../../../env";
import CommonToast from "../../../components/_utils/CommonToast";
import ICONS from "../../../assets/Icons";
import { toast } from "react-toastify";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
} from "../../../utils/configurationProvider";
import { getRefreshTokenNew } from "../refreshToken/refreshToken";
import { xpentraLogout } from "../logout/logout";

const baseUrl = env.REACT_APP_BASE_URL;

const updatedNotificationData = (
  state,
  updatedNotification,
  stateToUpdate,
  stateToUpdateSecondParam,
) => {
  const updatedId =
    updatedNotification?.id || updatedNotification?.notification_id;
  let updatedNotificationData = state[stateToUpdate];

  if (!updatedId || !state[stateToUpdate]) return;

  if (stateToUpdateSecondParam) {
    if (
      Array.isArray(
        updatedNotificationData[stateToUpdateSecondParam].notifications,
      )
    ) {
      updatedNotificationData[stateToUpdateSecondParam].notifications =
        updatedNotificationData[stateToUpdateSecondParam].notifications.map(
          (item) =>
            item?.id === updatedId || item?.notification_id === updatedId
              ? { ...item, ...updatedNotification }
              : item,
        );
    }
  } else {
    if (Array.isArray(state[stateToUpdate].notifications)) {
      state[stateToUpdate].notifications = state[
        stateToUpdate
      ].notifications.map((item) =>
        item?.id === updatedId || item?.notification_id === updatedId
          ? { ...item, ...updatedNotification, new: false }
          : { ...item, new: false },
      );
    }
  }
};

const applyNotificationCount = (state, responsePayload) => {
  if (!responsePayload?.summary || !state?.notificationsData) return;
  state.notificationsData = {
    ...state.notificationsData,
    summary: {
      ...(state.notificationsData?.summary || {}),
      ...responsePayload.summary,
    },
  };
};

const getNotificationId = (notification) =>
  notification?.id || notification?.notification_id;

const getPageNotifications = (pageData) => {
  if (!pageData) return [];
  if (Array.isArray(pageData.notifications)) return pageData.notifications;
  if (Array.isArray(pageData.data)) return pageData.data;
  return [];
};

const setPageNotifications = (pageData, notifications) => {
  if (!pageData) return;
  pageData.notifications = notifications;
  if (Array.isArray(pageData.data)) {
    pageData.data = notifications;
  }
};

const incrementNotificationMetadata = (pageData) => {
  if (!pageData) return;

  pageData.summary = {
    ...(pageData.summary || {}),
    unread:
      (Number(pageData.summary?.unread) ||
        GlobalConfiguration.lengthCheckZero) +
      GlobalConfiguration.lengthCheckOne,
  };

  if (pageData.title) {
    pageData.title.records =
      (pageData.title.records || GlobalConfiguration.lengthCheckZero) +
      GlobalConfiguration.lengthCheckOne;
  }

  pageData.total_count =
    (pageData.total_count || GlobalConfiguration.lengthCheckZero) +
    GlobalConfiguration.lengthCheckOne;
};

const updatedNotificationArrayData = (
  state,
  updatedNotification,
  stateToUpdate,
  stateToUpdateSecondParam,
  type,
  notificationLength,
  selectedValueLength,
  updatedSummary,
  cacheResponse,
) => {
  let updatedId =
    updatedNotification?.id || updatedNotification?.notification_id;
  let updatedNotificationData = state[stateToUpdate];
  if (!selectedValueLength) {
    if (!updatedId || !state[stateToUpdate]) return;
  }

  const resolveCacheNotifications = () => {
    if (Array.isArray(cacheResponse?.notifications)) {
      return cacheResponse.notifications;
    }
    if (Array.isArray(state.notificationsCacheData?.notifications)) {
      return state.notificationsCacheData.notifications;
    }
    return [];
  };

  const consumeCacheItem = (cacheNotifications) => {
    if (!cacheNotifications?.length) return null;
    return cacheNotifications[0];
  };

  const updateCacheAfterConsume = (cacheNotifications) => {
    const remaining = cacheNotifications?.slice(1) || [];
    if (cacheResponse) {
      state.notificationsCacheData = {
        ...state.notificationsCacheData,
        ...cacheResponse,
        notifications: remaining,
      };
    } else if (state.notificationsCacheData) {
      state.notificationsCacheData.notifications = remaining;
    }
  };

  const cacheNotifications = resolveCacheNotifications();
  const replacementItem = consumeCacheItem(cacheNotifications);

  const updateTitleAndCount = (payload, summaryType) => {
    if (!state[stateToUpdate]) return;
    const currentTitle = state[stateToUpdate]?.title || {};
    const records = payload?.summary?.[summaryType];
    if (records !== undefined) {
      state[stateToUpdate].title = {
        ...currentTitle,
        records,
      };
      state[stateToUpdate].total_count = records;
    }
  };

  if (stateToUpdateSecondParam) {
    if (
      Array.isArray(
        updatedNotificationData[stateToUpdateSecondParam].notifications,
      )
    ) {
      const filtered = updatedNotificationData[
        stateToUpdateSecondParam
      ].notifications.filter(
        (item) => item?.id !== updatedId && item?.notification_id !== updatedId,
      );
      if (state[stateToUpdate]?.title?.next_page && replacementItem) {
        filtered.push(replacementItem);
        updateCacheAfterConsume(cacheNotifications);
      }
      updatedNotificationData[stateToUpdateSecondParam].notifications =
        filtered;
    }
  } else {
    if (!selectedValueLength) {
      if (Array.isArray(state[stateToUpdate].notifications)) {
        let data = state[stateToUpdate].notifications.filter(
          (item) => item?.id !== updatedId,
        );
        if (state[stateToUpdate]?.title?.next_page && replacementItem) {
          data.push(replacementItem);
          updateCacheAfterConsume(cacheNotifications);
        }
        state[stateToUpdate].notifications = data;
        updateTitleAndCount(updatedNotification, type);
      }
    } else {
      if (Array.isArray(state[stateToUpdate].notifications)) {
        let data = state[stateToUpdate].notifications.filter(
          (item) => !updatedNotification?.includes(item?.id),
        );
        if (state[stateToUpdate]?.title?.next_page) {
          data = [
            ...data,
            ...(state.notificationsCacheData?.notifications || []).slice(
              0,
              notificationLength,
            ),
          ];
          state.notificationsCacheData.notifications =
            state?.notificationsCacheData?.notifications.slice(
              notificationLength,
            ) || [];
        }
        state[stateToUpdate].notifications = data;
        updateTitleAndCount(updatedSummary, type);
      }
    }
  }
};

export const channelCreate = createAsyncThunk(
  "channelCreate",
  async (values = {}, { rejectWithValue }) => {
    const { name, provider, url } = values;

    try {
      const response = await axiosInstance.post(
        `${baseUrl}/notifications/channels`,
        {
          name,
          provider,
          url,
        },
        {
          headers: {
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
            "Content-Type": "application/json",
          },
        },
      );
      return response?.data;
    } catch (error) {
      sessionStorage.setItem(
        "channel_error",
        JSON.stringify(error?.response?.data?.errors),
      );
      return rejectWithValue(error?.response?.data?.errors);
    }
  },
);
export const channelEdit = createAsyncThunk(
  "channelEdit",
  async (values = {}, { rejectWithValue }) => {
    const { id, name, provider, url, isActive, navigate } = values;

    try {
      const response = await axiosInstance.put(
        `${baseUrl}/notifications/channels/${id}`,
        {
          name,
          provider,
          url,
          is_active: isActive,
        },
        {
          headers: {
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
            "Content-Type": "application/json",
          },
        },
      );
      return response?.data;
    } catch (error) {
      if (error.response) {
        if (error.response.data?.errors?.user_unauthorized) {
          navigate("/feature_not_assigned", {
            state: { unavailableService: "UChannel" },
          });
        }
      }

      if (error?.response?.data?.error)
        CommonToast({
          text: error?.response?.data?.error,
          icon: ICONS.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      sessionStorage.setItem(
        "channel_error",
        JSON.stringify(error?.response?.data?.errors),
      );
      return rejectWithValue(error?.response?.data?.errors);
    }
  },
);

export const getSpecificChannel = createAsyncThunk(
  "getSpecificChannel",
  async (payload, { rejectWithValue }) => {
    const { id, page_no = 1, page_size = 50 } = payload;

    try {
      const response = await axiosInstance.get(
        `${baseUrl}/notifications/channels/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            page_no,
            page_size,
          },
        },
      );

      return response?.data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.errors?.base?.[0] ||
        error?.response?.data?.message ||
        error?.message ||
        "An unknown error occurred";

      if (error?.response?.status !== 404) {
        CommonToast({
          text: errorMessage,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
      }

      return rejectWithValue(error);
    }
  },
);

export const channelsViewAll = createAsyncThunk(
  "notifications/channelsViewAll",
  async (values = {}, { rejectWithValue }) => {
    const {
      name,
      provider,
      entity_id,
      is_active,
      notification_id,
      verification_status,
      start_date,
      end_date,
      page_no,
      page_size,
    } = values;

    try {
      const response = await axiosInstance.get(
        `${baseUrl}/notifications/channels`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
          params: {
            name,
            provider,
            entity_id,
            is_active,
            notification_id,
            verification_status,
            start_date,
            end_date,
            page_no,
            page_size,
          },
        },
      );
      return response?.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const testChannel = createAsyncThunk(
  "notifications/testChannel",

  async (payload, { rejectWithValue }) => {
    const { id } = payload;

    try {
      const response = await axiosInstance.get(
        `${baseUrl}/notifications/channels/${id}/test`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response?.data;
    } catch (error) {
      const errorMessage =
        error?.response?.data?.errors?.base?.[0] ||
        error?.response?.data?.errors ||
        error?.response?.data?.message ||
        error?.message ||
        "An unknown error occurred";

      toast.dismiss();
      CommonToast({
        text: `${errorMessage}.`,
        icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      return rejectWithValue(error);
    }
  },
);

export const notificationsBulkEdit = createAsyncThunk(
  "notifications/notificationsBulkEdit",
  async (values = {}, { rejectWithValue }) => {
    const { read, favourite, notification_ids, channel_id } = values;
    try {
      const response = await axiosInstance.patch(
        `${baseUrl}/notifications/user_notifications/bulk_update`,
        {
          read: String(read),
          favourite,
          notification_ids,
          channel_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response?.data;
    } catch (error) {
      if (error?.response?.data?.error)
        CommonToast({
          text: error?.response?.data?.error,
          icon: ICONS.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      return rejectWithValue(error);
    }
  },
);

export const notificationsViewAll = createAsyncThunk(
  "notifications/notificationsViewAll",
  async (values = {}, { rejectWithValue }) => {
    const {
      read,
      favourite,
      channel_id,
      search_string,
      start_date,
      end_date,
      start_ts,
      end_ts,
      provider,
      sort_by,
      active,
      page_no,
      snoozed,
      page_size,
    } = values;
    try {
      const response = await axiosInstance.get(`${baseUrl}/notifications`, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
        params: {
          read: read,
          favourite: favourite,
          channel_id: channel_id,
          search_string: search_string,
          start_date: start_date,
          end_date: end_date,
          start_ts: start_ts,
          end_ts: end_ts,
          provider: provider,
          sort_by: sort_by,
          active: active,
          page_no: page_no,
          page_size: page_size,
          snoozed: snoozed,
        },
      });
      return response?.data;
    } catch (error) {
      if (error?.response?.data?.error)
        CommonToast({
          text: error?.response?.data?.error,
          icon: ICONS.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      return rejectWithValue(error);
    }
  },
);

export const notificationsViewAllCache = createAsyncThunk(
  "notifications/notificationsViewAllCache",
  async (values = {}, { rejectWithValue }) => {
    const {
      read,
      favourite,
      channel_id,
      search_string,
      start_date,
      end_date,
      start_ts,
      end_ts,
      provider,
      sort_by,
      active,
      page_no,
      snoozed,
      page_size,
    } = values;
    try {
      const response = await axiosInstance.get(`${baseUrl}/notifications`, {
        headers: {
          "Content-Type": "application/json",
          "X-Api-Key": sessionStorage.getItem("q2p_token"),
        },
        params: {
          read: read,
          favourite: favourite,
          channel_id: channel_id,
          search_string: search_string,
          start_date: start_date,
          end_date: end_date,
          start_ts: start_ts,
          end_ts: end_ts,
          provider: provider,
          sort_by: sort_by,
          active: active,
          page_no: page_no,
          page_size: page_size,
          snoozed: snoozed,
        },
      });
      return response?.data;
    } catch (error) {
      if (error?.response?.data?.error)
        CommonToast({
          text: error?.response?.data?.error,
          icon: ICONS.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      return rejectWithValue(error);
    }
  },
);

export const markNotificationRead = createAsyncThunk(
  "notifications/markNotificationRead",
  async (values = {}, { rejectWithValue }) => {
    const { id, read } = values;
    try {
      const response = await axiosInstance.patch(
        `${baseUrl}/notifications/user_notifications/${id}/read`,
        {
          read: String(read),
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response?.data;
    } catch (error) {
      if (error?.response?.data?.error)
        CommonToast({
          text: error?.response?.data?.error,
          icon: ICONS.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      return rejectWithValue(error);
    }
  },
);

export const snoozeNotification = createAsyncThunk(
  "notifications/snoozeNotification",
  async (values = {}, { rejectWithValue }) => {
    const { id, snoozed_until } = values;
    try {
      const response = await axiosInstance.patch(
        `${baseUrl}/notifications/user_notifications/${id}/snooze`,
        {
          snoozed_until: snoozed_until,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response?.data;
    } catch (error) {
      if (error?.response?.data?.error)
        CommonToast({
          text: error?.response?.data?.error,
          icon: ICONS.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      return rejectWithValue(error);
    }
  },
);

export const unsnoozeNotification = createAsyncThunk(
  "notifications/unsnoozeNotification",
  async (values = {}, { rejectWithValue }) => {
    const { id } = values;
    try {
      const response = await axiosInstance.patch(
        `${baseUrl}/notifications/user_notifications/${id}/unsnooze`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response?.data;
    } catch (error) {
      if (error?.response?.data?.error)
        CommonToast({
          text: error?.response?.data?.error,
          icon: ICONS.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      return rejectWithValue(error);
    }
  },
);

export const favouriteNotification = createAsyncThunk(
  "notifications/favouriteNotification",
  async (values = {}, { rejectWithValue }) => {
    const { id, favourite } = values;
    try {
      const response = await axiosInstance.patch(
        `${baseUrl}/notifications/user_notifications/${id}/favourite`,
        {
          favourite: String(favourite),
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response?.data;
    } catch (error) {
      if (error?.response?.data?.error)
        CommonToast({
          text: error?.response?.data?.error,
          icon: ICONS.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      return rejectWithValue(error);
    }
  },
);

export const specificNotification = createAsyncThunk(
  "notifications/specificNotification",
  async (values = {}, { rejectWithValue }) => {
    const { id } = values;
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/notifications/${id}`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );
      return response?.data;
    } catch (error) {
      if (error?.response?.data?.error)
        CommonToast({
          text: error?.response?.data?.error,
          icon: ICONS.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",

          buttonNeeded: false,
        });
      return rejectWithValue(error);
    }
  },
);

export const notificationCreateConfiguration = createAsyncThunk(
  "notifications/notificationCreateConfiguration",
  async (values = {}, { rejectWithValue }) => {
    const { global_enabled, events } = values;

    try {
      const response = await axiosInstance.post(
        `${baseUrl}/notifications/configuration`,
        {
          global_enabled,
          events,
        },
        {
          headers: {
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
            "Content-Type": "application/json",
          },
        },
      );
      return response?.data;
    } catch (error) {
      if (error?.response?.data?.error) {
        CommonToast({
          text: error.response.data.error,
          icon: ICONS.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
      return rejectWithValue(error?.response?.data?.errors || error);
    }
  },
);

export const notificationShowConfiguration = createAsyncThunk(
  "notifications/notificationShowConfiguration",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${baseUrl}/notifications/configuration/show`,
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response?.data;
    } catch (error) {
      if (error?.response?.data?.error) {
        CommonToast({
          text: error.response.data.error,
          icon: ICONS.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }

      return rejectWithValue(error?.response?.data || error);
    }
  },
);

export const setUserNotificationPrefs = createAsyncThunk(
  "setUserNotificationPrefs",
  async (values, { rejectWithValue }) => {
    const { preferences } = values;
    try {
      const response = await axiosInstance.put(
        `${baseUrl}/users/set_preferences`,
        {
          preference_settings: {
            ...preferences,
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Api-Key": sessionStorage.getItem("q2p_token"),
          },
        },
      );

      return response.data;
    } catch (error) {
      if (error?.response?.status !== 401) {
        const message =
          error?.response?.data?.message ||
          error.message ||
          "Something went wrong while setting user notification preferences.";

        // Show toast
        CommonToast({
          text: message,
          icon: ICONS?.ERROR_WITH_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        return rejectWithValue({
          status: error?.response?.status || null,
          message,
        });
      }
    }
  },
);

const notificationsSlice = createSlice({
  name: "notificationsSlice",
  initialState: {
    notificationFilters: {},
    isBulkEdit: false,
    channelsData: null,
    channelsLoading: false,
    channelsError: null,

    createChannelLoading: false,
    createChannelData: null,
    createChannelError: null,

    editChannelLoading: false,
    editChannelData: null,
    editChannelError: null,

    getSpecificChannelLoading: false,
    getSpecificChannelError: null,
    getSpecificChannelData: null,

    getTestChannelDataLoading: false,
    getTestChannelData: null,
    getTestChannelDataError: null,

    notificationsData: null,
    notificationDashboardData: null,
    notificationsLoading: false,
    notificationsError: null,
    notificationsPageOneData: null,

    notificationsCacheData: null,
    notificationsCacheLoading: false,
    notificationsCacheError: null,

    markNotificationReadLoading: false,
    markNotificationReadError: null,
    markNotificationReadData: null,

    snoozeNotificationLoading: false,
    snoozeNotificationError: null,
    snoozeNotificationData: null,

    unsnoozeNotificationLoading: false,
    unsnoozeNotificationError: null,
    unsnoozeNotificationData: null,

    specificNotificationData: null,
    specificNotificationLoading: false,
    specificNotificationError: null,

    markFavouriteLoading: false,
    markFavouriteError: null,
    markFavouriteData: null,

    notificationCreateConfigLoading: false,
    notificationCreateConfigError: null,
    notificationCreateConfigData: null,

    notificationShowConfigLoading: false,
    notificationShowConfigError: null,
    notificationShowConfigData: null,

    notificationsBulkEditLoading: false,
    notificationsBulkEditError: null,
    notificationsBulkEditData: null,

    notiID: "",
    cardAnimate: false,

    setUserNotificationPrefsStatus: null,
    setUserNotificationPrefsLoading: null,
    setUserNotificationPrefsError: null,
  },
  reducers: {
    setNotificationFilters: (state, action) => {
      state.notificationFilters = action.payload || {};
    },
    setBulkEditState: (state, action) => {
      state.isBulkEdit = action.payload;
    },
    setNotiID: (state, action) => {
      state.notiID = action.payload;
    },
    setCardAnimate: (state, action) => {
      state.cardAnimate = action.payload;
    },
    addNotificationToStore: (state, action) => {
      const notification = action.payload;
      notification.new = true;
      const notificationId = getNotificationId(notification);
      if (!notification || !state.notificationsData || !notificationId) return;
      if (state.isBulkEdit) {
        return;
      }
      const filters = state.notificationFilters || {};
      const now = Date.now();

      const isRead =
        notification?.read === true ||
        notification?.read === "true" ||
        notification?.is_read === true ||
        notification?.is_read === "true";

      const isFavourite = notification?.favourite ?? false;

      const isSnoozed =
        Number(notification?.snoozed_until) >
        Math.floor(now / IntervalConfiguration.intervalMedium);

      if (filters.read !== undefined && isRead !== filters.read) {
        return;
      }

      if (
        filters.favourite !== undefined &&
        isFavourite !== filters.favourite
      ) {
        return;
      }

      if (filters.snoozed === true && !isSnoozed) {
        return;
      }

      if (filters.start_date && filters.end_date) {
        const notificationDate = notification?.created_at
          ? new Date(
              notification.created_at * IntervalConfiguration.intervalMedium,
            )
          : notification?.created_on
            ? new Date(
                notification.created_on * IntervalConfiguration.intervalMedium,
              )
            : new Date(notification?.date);

        const [startDay, startMonth, startYear] = filters.start_date.split("-");

        const [endDay, endMonth, endYear] = filters.end_date.split("-");

        const startDate = new Date(
          startYear,
          startMonth - GlobalConfiguration.lengthCheckOne,
          startDay,
          0,
          0,
          0,
          0,
        );

        const endDate = new Date(
          endYear,
          endMonth - GlobalConfiguration.lengthCheckOne,
          endDay,
          23,
          59,
          59,
          999,
        );

        if (notificationDate < startDate || notificationDate > endDate) {
          return;
        }
      }
      const MAX_ITEMS =
        Number(state.notificationsData.page_size) ||
        PaginationConfiguration.paginationSmall;
      const currentPage =
        Number(state.notificationsData.page_no) ||
        GlobalConfiguration.lengthCheckOne;
      const notifications = getPageNotifications(state.notificationsData);

      const existsInCurrentPage = notifications.some(
        (item) => getNotificationId(item) === notificationId,
      );
      const existsInCachedPage = getPageNotifications(
        state.notificationsCacheData,
      ).some((item) => getNotificationId(item) === notificationId);
      const existsInPageOne = getPageNotifications(
        state.notificationsPageOneData,
      ).some((item) => getNotificationId(item) === notificationId);

      if (existsInCurrentPage || existsInCachedPage || existsInPageOne) return;

      if (currentPage === GlobalConfiguration.lengthCheckOne) {
        state.cardAnimate = true;
        state.notiID = notificationId;

        const nextNotifications = [notification, ...notifications];
        let shiftedNotification = null;

        if (nextNotifications.length > MAX_ITEMS) {
          shiftedNotification = nextNotifications.pop();
        }

        setPageNotifications(state.notificationsData, nextNotifications);
        if (shiftedNotification && state.notificationsCacheData) {
          const cachedNotifications = getPageNotifications(
            state.notificationsCacheData,
          );

          const nextCachedNotifications = [
            shiftedNotification,
            ...cachedNotifications,
          ].slice(0, MAX_ITEMS);

          setPageNotifications(
            state.notificationsCacheData,
            nextCachedNotifications,
          );
        }

        incrementNotificationMetadata(state.notificationsData);

        incrementNotificationMetadata(state.notificationsCacheData);

        return;
      }

      incrementNotificationMetadata(state.notificationsData);
      incrementNotificationMetadata(state.notificationsPageOneData);
      incrementNotificationMetadata(state.notificationsCacheData);
    },
    updateNotificationCount: (state, action) => {
      applyNotificationCount(state, action?.payload);
    },
    updateNotificationInStore: (state, action) => {
      updatedNotificationData(
        state,
        action?.payload?.response,
        action?.payload?.stateToUpdate,
        action?.payload?.stateToUpdateSecondParam,
      );
    },

    updateNotificationArrayInStore: (state, action) => {
      updatedNotificationArrayData(
        state,
        action?.payload?.response,
        action?.payload?.stateToUpdate,
        action?.payload?.stateToUpdateSecondParam,
        action?.payload?.notificationType,
        action?.payload?.notificationLength,
        action?.payload?.selectedValueLength,
        action?.payload?.updatedSummary,
      );
    },

    resetEditChannel(state) {
      state.editChannelData = null;
    },

    resetNotificationsData: (state) => {
      state.notificationsData = null;
    },

    updateChannelDetailData: (state, action) => {
      state.getSpecificChannelData = {
        ...state.getSpecificChannelData,
        ...action.payload,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(channelsViewAll.pending, (state) => {
      state.channelsLoading = true;
      state.channelsError = null;
    });
    builder.addCase(channelsViewAll.fulfilled, (state, action) => {
      state.channelsLoading = false;
      state.channelsData = action?.payload;
    });
    builder.addCase(channelsViewAll.rejected, (state, action) => {
      state.channelsLoading = false;
      state.channelsData = null;
      state.channelsError = action?.payload;
    });

    builder.addCase(notificationsViewAll.pending, (state) => {
      state.notificationsLoading = true;
      state.notificationsError = null;
    });
    builder.addCase(notificationsViewAll.fulfilled, (state, action) => {
      state.notificationsData = {
        ...action?.payload,
        page_no:
          action?.meta?.arg?.page_no || GlobalConfiguration.lengthCheckOne,
        page_size:
          action?.meta?.arg?.page_size ||
          PaginationConfiguration.paginationSmall,
      };
      state.notificationDashboardData = {
        ...action?.payload,
      };
      if (
        Number(
          action?.meta?.arg?.page_no || GlobalConfiguration.lengthCheckOne,
        ) === GlobalConfiguration.lengthCheckOne
      ) {
        state.notificationsPageOneData = {
          ...action?.payload,
          page_no: GlobalConfiguration.lengthCheckOne,
          page_size:
            action?.meta?.arg?.page_size ||
            PaginationConfiguration.paginationSmall,
        };
      }
      state.notificationsLoading = false;
    });
    builder.addCase(notificationsViewAll.rejected, (state, action) => {
      state.notificationsLoading = false;
      state.notificationsData = null;
      state.notificationsError = action?.payload;
    });

    builder.addCase(notificationsViewAllCache.pending, (state) => {
      state.notificationsCacheLoading = true;
      state.notificationsCacheError = null;
    });
    builder.addCase(notificationsViewAllCache.fulfilled, (state, action) => {
      state.notificationsCacheLoading = false;
      state.notificationsCacheData = {
        ...action?.payload,
        page_no: action?.meta?.arg?.page_no,
        page_size:
          action?.meta?.arg?.page_size ||
          PaginationConfiguration.paginationSmall,
      };
      if (
        Number(action?.meta?.arg?.page_no) ===
        GlobalConfiguration.lengthCheckOne
      ) {
        state.notificationsPageOneData = {
          ...action?.payload,
          page_no: GlobalConfiguration.lengthCheckOne,
          page_size:
            action?.meta?.arg?.page_size ||
            PaginationConfiguration.paginationSmall,
        };
      }
      if (state.notificationsData) {
        let data = {
          ...state.notificationsData.title,
          records: action?.payload?.title?.records,
          total_pages: action?.payload?.title?.total_pages,
        };
        state.notificationsData.title = data;
        state.notificationsData.total_count = action?.payload?.total_count;
      }
    });
    builder.addCase(notificationsViewAllCache.rejected, (state, action) => {
      state.notificationsCacheLoading = false;
      state.notificationsCacheData = null;
      state.notificationsCacheError = action?.payload;
    });

    builder.addCase(notificationsBulkEdit.pending, (state) => {
      state.notificationsBulkEditLoading = true;
      state.notificationsBulkEditError = null;
    });
    builder.addCase(notificationsBulkEdit.fulfilled, (state, action) => {
      state.notificationsBulkEditLoading = false;
      state.notificationsBulkEditData = action?.payload;
    });
    builder.addCase(notificationsBulkEdit.rejected, (state, action) => {
      state.notificationsBulkEditLoading = false;
      state.notificationsBulkEditData = null;
      state.notificationsBulkEditError = action?.payload;
    });

    builder.addCase(markNotificationRead.pending, (state) => {
      state.markNotificationReadLoading = true;
      state.markNotificationReadError = null;
    });
    builder.addCase(markNotificationRead.fulfilled, (state, action) => {
      state.markNotificationReadLoading = false;
      state.markNotificationReadData = action?.payload;
    });
    builder.addCase(markNotificationRead.rejected, (state, action) => {
      state.markNotificationReadLoading = false;
      state.markNotificationReadData = null;
      state.markNotificationReadError = action?.payload;
    });
    builder.addCase(snoozeNotification.pending, (state) => {
      state.snoozeNotificationLoading = true;
      state.snoozeNotificationError = null;
    });
    builder.addCase(snoozeNotification.fulfilled, (state, action) => {
      state.snoozeNotificationLoading = false;
      state.snoozeNotificationData = action?.payload;
    });
    builder.addCase(snoozeNotification.rejected, (state, action) => {
      state.snoozeNotificationLoading = false;
      state.snoozeNotificationData = null;
      state.snoozeNotificationError = action?.payload;
    });
    builder.addCase(unsnoozeNotification.pending, (state) => {
      state.unsnoozeNotificationLoading = true;
      state.unsnoozeNotificationError = null;
    });
    builder.addCase(unsnoozeNotification.fulfilled, (state, action) => {
      state.unsnoozeNotificationLoading = false;
      state.unsnoozeNotificationData = action?.payload;
      updatedNotificationData(state, action?.payload, "notificationsData");
    });
    builder.addCase(unsnoozeNotification.rejected, (state, action) => {
      state.unsnoozeNotificationLoading = false;
      state.unsnoozeNotificationData = null;
      state.unsnoozeNotificationError = action?.payload;
    });
    builder.addCase(specificNotification.pending, (state) => {
      state.specificNotificationLoading = true;
      state.specificNotificationError = null;
    });
    builder.addCase(specificNotification.fulfilled, (state, action) => {
      state.specificNotificationLoading = false;
      state.specificNotificationData = action?.payload;
    });
    builder.addCase(specificNotification.rejected, (state, action) => {
      state.specificNotificationLoading = false;
      state.specificNotificationData = null;
      state.specificNotificationError = action?.payload;
    });
    builder.addCase(favouriteNotification.pending, (state) => {
      state.markFavouriteLoading = true;
      state.markFavouriteError = null;
    });
    builder.addCase(favouriteNotification.fulfilled, (state, action) => {
      state.markFavouriteLoading = false;
      state.markFavouriteData = action?.payload;
    });
    builder.addCase(favouriteNotification.rejected, (state, action) => {
      state.markFavouriteLoading = false;
      state.markFavouriteData = null;
      state.markFavouriteError = action?.payload;
    });
    builder.addCase(channelCreate.pending, (state) => {
      state.createChannelLoading = true;
      state.createChannelError = null;
    });
    builder.addCase(channelCreate.fulfilled, (state, action) => {
      state.createChannelLoading = false;
      state.createChannelData = action?.payload;
    });
    builder.addCase(channelCreate.rejected, (state, action) => {
      state.createChannelLoading = false;
      state.createChannelData = null;
      state.createChannelError = action?.payload;
    });
    builder.addCase(channelEdit.pending, (state) => {
      state.editChannelLoading = true;
      state.editChannelError = null;
    });
    builder.addCase(channelEdit.fulfilled, (state, action) => {
      state.editChannelLoading = false;
      state.editChannelData = action?.payload;
    });
    builder.addCase(channelEdit.rejected, (state, action) => {
      state.editChannelLoading = false;
      state.editChannelData = null;
      state.editChannelError = action?.payload;
    });
    builder.addCase(getSpecificChannel.pending, (state) => {
      state.getSpecificChannelLoading = true;
      state.getSpecificChannelError = null;
    });
    builder.addCase(getSpecificChannel.fulfilled, (state, action) => {
      state.getSpecificChannelLoading = false;
      state.getSpecificChannelData = action?.payload;
    });
    builder.addCase(getSpecificChannel.rejected, (state, action) => {
      state.getSpecificChannelLoading = false;
      state.getSpecificChannelData = null;
      state.getSpecificChannelError = action?.payload;
    });
    builder.addCase(testChannel.pending, (state, action) => {
      state.getTestChannelDataLoading = true;
      state.getTestChannelData = action?.payload;
      state.getTestChannelDataError = null;
    });
    builder.addCase(testChannel.fulfilled, (state, action) => {
      state.getTestChannelDataLoading = false;
      state.getTestChannelData = action?.payload;
      state.getTestChannelDataError = null;
    });
    builder.addCase(testChannel.rejected, (state, action) => {
      state.getTestChannelDataLoading = false;
      state.getTestChannelData = null;
      state.getTestChannelDataError = action?.payload;
    });
    builder.addCase(notificationCreateConfiguration.pending, (state) => {
      state.notificationCreateConfigLoading = true;
      state.notificationCreateConfigError = null;
    });
    builder.addCase(
      notificationCreateConfiguration.fulfilled,
      (state, action) => {
        state.notificationCreateConfigLoading = false;
        state.notificationCreateConfigData = action?.payload;
      },
    );
    builder.addCase(
      notificationCreateConfiguration.rejected,
      (state, action) => {
        state.notificationCreateConfigLoading = false;
        state.notificationCreateConfigData = null;
        state.notificationCreateConfigError = action?.payload;
      },
    );
    builder.addCase(notificationShowConfiguration.pending, (state) => {
      state.notificationShowConfigLoading = true;
      state.notificationShowConfigError = null;
    });
    builder.addCase(
      notificationShowConfiguration.fulfilled,
      (state, action) => {
        state.notificationShowConfigLoading = false;
        state.notificationShowConfigData = action?.payload;
      },
    );
    builder.addCase(notificationShowConfiguration.rejected, (state, action) => {
      state.notificationShowConfigLoading = false;
      state.notificationShowConfigData = null;
      state.notificationShowConfigError = action?.payload;
    });
    builder.addCase(getRefreshTokenNew.fulfilled, (state, action) => {
      state.notificationShowConfigData =
        action.payload?.employees?.preference_settings || null;
    });

    builder.addCase(setUserNotificationPrefs.pending, (state, action) => {
      state.setUserNotificationPrefsLoading = true;
      state.setUserNotificationPrefsError = null;
    });
    builder.addCase(setUserNotificationPrefs.fulfilled, (state, action) => {
      state.notificationShowConfigData = action.payload?.preference_settings;
      state.setUserNotificationPrefsLoading = false;
    });
    builder.addCase(setUserNotificationPrefs.rejected, (state, action) => {
      state.setUserNotificationPrefsLoading = false;
      state.setUserNotificationPrefsError = action?.payload;
    });

    builder.addCase(xpentraLogout.fulfilled, (state) => {
      // Clear notification config on logout to ensure fresh preferences are fetched from the server.
      state.notificationShowConfigData = null;
    });
  },
});

export const {
  updateNotificationCount,
  updateNotificationInStore,
  resetEditChannel,
  setNotificationFilters,
  updateChannelDetailData,
  setBulkEditState,
  updateNotificationArrayInStore,
  addNotificationToStore,
  setNotiID,
  setCardAnimate,
  resetNotificationsData,
} = notificationsSlice.actions;
export default notificationsSlice.reducer;
